module.exports = __webpack_public_path__ + "static/media/z1r_01.aac39964.jpg";